import { Component, OnInit } from '@angular/core';
import { RolesService } from '../../services/roles-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss']
})
export class AddRoleComponent implements OnInit {

  model = {} as any;
  attachements = new FormData();
  isEdit = false;
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<AddRoleComponent>,
    private service: RolesService,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
  }

  save(){
    this.service.post(this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم إضافة  صلاحية جديدة بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  update(){
    this.service.put(this.model.id, this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  close() {
    this.diagRef.close();
  }

}
